import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import {
  ButtonVariantContained, ButtonVariantText, ButtonVariantOutlined
} from "../buttons/constants.js";

import SmartLink from './smart_link.js';

const styles = theme => ({
  root: {
  },
});

// className = { clsx(classes.button, classes.preview) }
// variant = { ButtonVariantOutlined }
// to = { WebRoutes.project(this.item) }
// target = { "_blank" }
/**
 * Looks line {@link Button} link. Has behavior like {@link SmartLink}
 * @name ButtonLink
 * @param {object} props React component properties
 * @param {string} [props.to] Url for href
 * @param {string} [props.className] CSS-class name
 * @param {string} [props.target] Standard target attribute for links ("_blank", "_current" etc)
 * @param {string} [props.component] Component. If the prop passed, in html-layout will draw element with value of property
 * @param {string} [props.variant = "contained"] View variant for button stylization. Available values:
 *  - {@link https://material-ui.com/components/buttons/#contained-buttons|"contained"}
 *  - {@link https://material-ui.com/components/buttons/#outlined-buttons|"outlined"}
 *  - {@link https://material-ui.com/components/buttons/#text-buttons|"text"}
 * 
 * NOTE: for providing variant, please, import necessary variant as constant from file "components/base/buttons/constants.js.jsx"
 * @example
 * return (
 *    <ButtonLink className = { "link" }
 *               to = { "http://domain.com/page/url" }>
 *      { "CLICK ME!" }
 *    </ButtonLink>
 * )
*/
class ButtonLink extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    }
  }

  static getDerivedStateFromProps(props, state) {
    return {
      disabled: props.disabled
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.disabled !== nextState.disabled;
  }

  render() {
    const { classes, className } = this.props;

    const { target, children, to, variant, component } = this.props;

    const { disabled } = this.state;

    return <Button className = { clsx(classes.root, className) } 
                   disabled = { disabled }
                   variant = { variant }
                   component = { component || SmartLink }
                   target = { target }
                   to = { to } >
      { children }
    </Button>
  }
}

ButtonLink.propTypes = {
  variant: PropTypes.oneOf([
    ButtonVariantContained, ButtonVariantText, ButtonVariantOutlined
  ])
};

ButtonLink.defaultProps = {
  disabled: false,
  variant: ButtonVariantContained
}

export default withStyles(styles)(ButtonLink);
